(function () {
    'use strict';

    angular
        .module('atheer.content')
        .controller('DocumentDetailController', DocumentDetailController)
        .controller('DocumentViewController', DocumentViewController)
        .controller('DocumentFeedbackController', DocumentFeedbackController)

    /* @ngInject */
    function DocumentFeedbackController($scope, $mdBottomSheet) {
    }

    /* @ngInject */
    function DocumentViewController($scope, $controller, $mdBottomSheet) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.showFeedback = function (firstTime) {

            $mdBottomSheet.show({
                templateUrl: 'modules/content/document-feedback.tmpl.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'DocumentFeedbackController',
                scope: $scope,
                preserveScope: true,
                parent: '#fp-content-view-' + $scope.data.id + '-' + $scope.context,
                disableParentScroll: true,
                locals: {
                    firstTime: firstTime
                }
            });
        }
    }

    /* @ngInject */
    function DocumentDetailController($scope, $timeout, $controller, id, Content, triLoaderService, $state, $stateParams, $interval, $filter, ToastService, PermissionService, User, $q, Principal, $mdToast) {
        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "document"
        });
        angular.extend(this, basectrl);

        var vm = this;
        var PROCESS_STATUS_POLL_INTERVAL_MS = 5000;
        var PROCESS_STATUS_POLL_MAX_MS = 15 * 60 * 1000;
        var TERMINAL_PROCESS_STATUSES = ['READY_FOR_REVIEW', 'FAILED', 'COMPLETED'];
        var IN_PROGRESS_PROCESS_STATUSES = ['PENDING', 'IN_PROGRESS', 'PROCESSING_FOR_TAGS_GENERATION'];
        var tagRegenerationStartedAt = 0;
        var observedInProgressDuringRegeneration = false;
        var editorDisplayNameCache = {};

        vm.documentProcessingStatus = null;
        vm.isPollingDocumentProcessStatus = false;

        vm.documentVersions = [];
        vm.activeVersionContentId = null;
        vm.isUploadingNewVersion = false;
        vm.pendingNewVersionListingToast = false;
        vm.versionParentContent = null;
        vm.loadingDocumentVersion = false;
        vm.hasVersioningAccess = PermissionService.hasAccess('versioning-content');

        var baseIsNew = vm.isNew;
        vm.isNew = function () {
            return vm.isUploadingNewVersion || baseIsNew.call(vm);
        };

        function getVersionCreateFields(parent) {
            return {
                family_id: parent.family_id || parent.id,
                version: (parent.version || 1) + 1
            };
        }

        function isArchivedStatus(status) {
            return (status || '').toLowerCase() === 'archived';
        }

        function getActiveVersionContentId(entries) {
            var list = (entries || []).filter(function (entry) {
                return !!entry;
            });

            if (!list.length) {
                return null;
            }

            var nonArchived = list.filter(function (entry) {
                return !isArchivedStatus(entry.status);
            });
            var pool = nonArchived.length ? nonArchived : list;

            var activeEntry = pool.reduce(function (latest, entry) {
                if (!latest || (entry.version || 0) > (latest.version || 0)) {
                    return entry;
                }
                return latest;
            }, null);

            return activeEntry ? (activeEntry.content_id || activeEntry.id) : null;
        }

        function normalizeVersionStatus(entry, entries) {
            if (!entry) {
                return 'archived';
            }

            if (entry.status) {
                return isArchivedStatus(entry.status) ? 'archived' : 'active';
            }

            var contentId = entry.content_id || entry.id;
            var activeContentId = getActiveVersionContentId(entries);

            return activeContentId && contentId === activeContentId ? 'active' : 'archived';
        }

        function enrichVersionsWithMeta(versions, versioningMeta) {
            var metaByVersion = {};
            var metaByContentId = {};

            angular.forEach(versioningMeta || [], function (meta) {
                if (!meta) {
                    return;
                }
                if (meta.version != null) {
                    metaByVersion[String(meta.version)] = meta;
                }
                var metaContentId = meta.content_id || meta.id;
                if (metaContentId) {
                    metaByContentId[metaContentId] = meta;
                }
            });

            return (versions || []).map(function (entry) {
                if (!entry) {
                    return entry;
                }
                var contentId = entry.content_id || entry.id;
                var meta = (contentId && metaByContentId[contentId])
                    || (entry.version != null && metaByVersion[String(entry.version)])
                    || {};

                return {
                    content_id: contentId || meta.content_id || meta.id || null,
                    id: entry.id || contentId || meta.id || meta.content_id || null,
                    title: entry.title || meta.title,
                    version: entry.version != null ? entry.version : meta.version,
                    edited_by: entry.edited_by || meta.edited_by || '',
                    updated_on: entry.updated_on || meta.updated_on || entry.created_on || meta.created_on,
                    status: entry.status || meta.status
                };
            });
        }

        function getCachedEditorName(key) {
            if (!key) {
                return '';
            }
            return editorDisplayNameCache[key] || editorDisplayNameCache[String(key).toLowerCase()] || '';
        }

        function setCachedEditorName(key, name) {
            if (!key || !name) {
                return;
            }
            editorDisplayNameCache[key] = name;
            editorDisplayNameCache[String(key).toLowerCase()] = name;
        }

        function formatUserDisplayName(user) {
            if (!user) {
                return '';
            }
            return [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
        }

        function quoteRsqlValue(value) {
            return '"' + String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
        }

        function seedEditorNameCacheFromPrincipal() {
            var me = Principal.getUserInfo && Principal.getUserInfo();
            if (!me) {
                return;
            }
            var myName = formatUserDisplayName(me);
            if (!myName && Principal.getUserFullName) {
                myName = (Principal.getUserFullName() || '').trim();
            }
            if (!myName) {
                return;
            }
            if (me.email) {
                setCachedEditorName(me.email, myName);
            }
            if (me.login) {
                setCachedEditorName(me.login, myName);
            }
            if (me.id) {
                setCachedEditorName(me.id, myName);
            }
        }

        function needsEditorNameLookup(value) {
            if (!value || !angular.isString(value)) {
                return false;
            }
            if (getCachedEditorName(value)) {
                return false;
            }
            // Email/login/id rather than an already-resolved "First Last" display name.
            return value.indexOf('@') !== -1 || value.indexOf(' ') === -1;
        }

        function cacheUserDisplayName(user, keys) {
            var displayName = formatUserDisplayName(user);
            if (!displayName) {
                return;
            }
            if (user.email) {
                setCachedEditorName(user.email, displayName);
            }
            if (user.login) {
                setCachedEditorName(user.login, displayName);
            }
            if (user.id) {
                setCachedEditorName(user.id, displayName);
            }
            angular.forEach(keys || [], function (key) {
                if (!key || getCachedEditorName(key)) {
                    return;
                }
                var lower = String(key).toLowerCase();
                if ((user.email && user.email.toLowerCase() === lower) ||
                    (user.login && user.login.toLowerCase() === lower) ||
                    (user.id && user.id === key)) {
                    setCachedEditorName(key, displayName);
                }
            });
        }

        function applyCachedEditorNames(versions) {
            angular.forEach(versions || [], function (ver) {
                var key = ver.editorKey || ver.editorDisplay;
                var cachedName = getCachedEditorName(key);
                if (cachedName) {
                    ver.editorDisplay = cachedName;
                }
            });
        }

        function resolveEditorDisplayNames(versions) {
            seedEditorNameCacheFromPrincipal();

            var lookupKeys = {};
            angular.forEach(versions || [], function (ver) {
                var key = ver.editorKey || ver.editorDisplay;
                if (!key) {
                    return;
                }
                ver.editorKey = key;
                var cachedName = getCachedEditorName(key);
                if (cachedName) {
                    ver.editorDisplay = cachedName;
                    return;
                }
                if (needsEditorNameLookup(key)) {
                    lookupKeys[key] = true;
                }
            });

            var keys = Object.keys(lookupKeys);
            if (!keys.length) {
                applyCachedEditorNames(versions);
                return $q.when(versions);
            }

            // Match the people-search query shape used elsewhere in studio (email/login + check_admin).
            var requests = keys.map(function (key) {
                var quoted = quoteRsqlValue(key);
                var searchQuery = '(' +
                    'email==' + quoted +
                    ',login==' + quoted +
                    ',email=re=' + quoted +
                    ',login=re=' + quoted +
                    ')';

                return User.query({
                    page: 0,
                    size: 5,
                    check_admin: true,
                    query: searchQuery
                }).$promise.then(function (matchedUsers) {
                    angular.forEach(matchedUsers || [], function (user) {
                        cacheUserDisplayName(user, [key]);
                    });
                }, angular.noop);
            });

            return $q.all(requests).then(function () {
                applyCachedEditorNames(versions);
                return versions;
            });
        }

        function mapVersionEntries(entries) {
            var filtered = (entries || []).filter(function (entry) {
                return !!entry;
            });

            return filtered.map(function (entry) {
                var editorKey = entry.edited_by || '';
                var cachedName = getCachedEditorName(editorKey);
                var looksLikeLoginOrEmail = !!editorKey &&
                    (editorKey.indexOf('@') !== -1 || editorKey.indexOf(' ') === -1);
                return {
                    contentId: entry.content_id || entry.id,
                    title: entry.title,
                    versionNumber: entry.version,
                    editorKey: editorKey,
                    // Prefer resolved name; avoid flashing email/login while lookup runs.
                    editorDisplay: cachedName || (looksLikeLoginOrEmail ? '' : editorKey),
                    editedOn: entry.updated_on || entry.created_on,
                    status: normalizeVersionStatus(entry, filtered)
                };
            }).sort(function (a, b) {
                return b.versionNumber - a.versionNumber;
            });
        }

        function applyDocumentVersions(versions) {
            var enriched = enrichVersionsWithMeta(versions, vm.contentModel && vm.contentModel.versioning);
            vm.activeVersionContentId = getActiveVersionContentId(enriched);
            vm.documentVersions = mapVersionEntries(enriched);
            resolveEditorDisplayNames(vm.documentVersions);
        }

        function refreshDocumentVersions() {
            if (!vm.contentModel || vm.isNew() || !vm.contentModel.id) {
                vm.documentVersions = [];
                vm.activeVersionContentId = null;
                return;
            }
            var familyId = vm.contentModel.family_id || vm.contentModel.id;
            vm.loadingDocumentVersion = true;
            Content.getVersions({ id: familyId, exclude_archived: true }, function (versions) {
                if (vm.contentModel && (vm.contentModel.family_id || vm.contentModel.id) === familyId) {
                    applyDocumentVersions(versions);
                }
                vm.loadingDocumentVersion = false;
            }, function () {
                if (vm.contentModel && (vm.contentModel.family_id || vm.contentModel.id) === familyId) {
                    applyDocumentVersions(vm.contentModel.versioning);
                }
                vm.loadingDocumentVersion = false;
            });
        }

        $scope.$watch(function () {
            return vm.contentModel && (vm.contentModel.id + ':' + (vm.contentModel.versioning || []).length);
        }, refreshDocumentVersions);

        vm.isArchivedVersionStatus = function (status) {
            return isArchivedStatus(status);
        };

        vm.isActiveVersionStatus = function (status) {
            return !vm.isArchivedVersionStatus(status);
        };

        vm.isViewingReadOnlyDocument = function () {
            if (!vm.contentModel || !vm.contentModel.id) {
                return false;
            }

            if (isArchivedStatus(vm.contentModel.status)) {
                return true;
            }

            return !!(vm.activeVersionContentId && vm.contentModel.id !== vm.activeVersionContentId);
        };

        vm.froalaOptions = {
            readOnly: false
        };

        function applyDocumentReadOnlyState() {
            var isReadOnly = vm.isViewingReadOnlyDocument();
            vm.froalaOptions.readOnly = isReadOnly;
            if (isReadOnly) {
                vm.contentMetaData.show_versioning = true;
            }
        }

        function guardReadOnlyAction(action) {
            return function () {
                if (vm.isViewingReadOnlyDocument()) {
                    return;
                }
                return action.apply(vm, arguments);
            };
        }

        vm.save = guardReadOnlyAction(vm.save);
        vm.saveOnAction = guardReadOnlyAction(vm.saveOnAction);
        vm.saveNoAlert = guardReadOnlyAction(vm.saveNoAlert);
        vm.openShareDialog = guardReadOnlyAction(vm.openShareDialog);
        vm.openAssignModal = guardReadOnlyAction(vm.openAssignModal);
        vm.regenerateAutoTags = guardReadOnlyAction(vm.regenerateAutoTags);

        vm.isCurrentDocumentVersion = function (ver) {
            return !!(ver && ver.contentId && vm.contentModel && ver.contentId === vm.contentModel.id);
        };

        vm.canSelectDocumentVersion = function (ver) {
            return !!(ver && ver.contentId && !vm.isCurrentDocumentVersion(ver) && !vm.loadingDocumentVersion);
        };

        vm.selectDocumentVersion = function (ver) {
            if (!vm.canSelectDocumentVersion(ver)) {
                return;
            }
            $state.go('storm.admin-content-detail', {
                contentType: 'document',
                id: ver.contentId,
                page: $stateParams.page,
                size: $stateParams.size,
                search: $stateParams.search
            }, { reload: true });
        };

        $scope.$watch(function () {
            return vm.contentModel && vm.contentModel.id;
        }, applyDocumentReadOnlyState);

        $scope.$watch(function () {
            return vm.contentModel && vm.contentModel.status;
        }, applyDocumentReadOnlyState);

        var baseShowSaveShareButton = vm.showSaveShareButton;
        vm.showSaveShareButton = function () {
            if (vm.isViewingReadOnlyDocument()) {
                return true;
            }
            return baseShowSaveShareButton.call(vm);
        };

        vm.beginUploadNewVersion = function () {
            if (!vm.hasVersioningAccess || vm.isViewingReadOnlyDocument()) {
                return;
            }
            var parent = angular.copy(vm.contentModel);
            vm.versionParentContent = parent;

            // Clear id before flipping the flag so the save-watch never persists the parent id.
            var nextModel = angular.copy(parent);
            nextModel.id = null;
            nextModel.data = nextModel.data || {};
            nextModel.data.source_media = null;
            nextModel.data.doc_status = null;
            nextModel.data.auto_tags = [];
            nextModel.auto_tags = [];
            delete nextModel.versioning;
            angular.extend(nextModel, getVersionCreateFields(parent));

            vm.contentModel = nextModel;
            vm.isUploadingNewVersion = true;
            vm.pendingNewVersionListingToast = true;
            vm.extractStatus = 'IDLE';
            vm.processStatus = 'IDLE';
            vm.uploadStatus = 'idle';
        };

        vm.showAddNewVersionButton = function () {
            if (!vm.hasVersioningAccess || !vm.contentMetaData.enable_versioning || vm.isUploadingNewVersion) {
                return false;
            }
            if (!vm.contentModel || !vm.contentModel.id) {
                return false;
            }
            return vm.showSaveShareButton();
        };

        $scope.$watch(function () {
            return vm.loadingData;
        }, function (loading) {
            if (loading || !$stateParams.uploadNewVersion || !vm.hasVersioningAccess || !vm.contentModel || !vm.contentModel.id || vm.isUploadingNewVersion) {
                return;
            }
            vm.beginUploadNewVersion();
        });

        $scope.$watch(function () {
            return vm.isUploadingNewVersion && vm.contentModel && vm.contentModel.id;
        }, function (savedNewVersion) {
            if (!savedNewVersion) {
                return;
            }
            persistPendingNewVersionToast(vm.contentModel.id, vm.contentModel.title);
            vm.pendingNewVersionListingToast = true;
            vm.isUploadingNewVersion = false;
            vm.versionParentContent = null;
            $stateParams.uploadNewVersion = false;
            refreshDocumentVersions();
            showNewVersionUploadedToast();
        });

        function readPendingNewVersionToastMap(key) {
            var pending = {};
            function mergeFromRaw(raw) {
                if (!raw) {
                    return;
                }
                try {
                    var parsed = angular.fromJson(raw);
                    if (parsed && typeof parsed === 'object' && !angular.isArray(parsed)) {
                        angular.extend(pending, parsed);
                    }
                } catch (e) {
                    // Ignore parse errors.
                }
            }
            try {
                mergeFromRaw(sessionStorage.getItem(key));
            } catch (e) { /* ignore */ }
            try {
                mergeFromRaw(localStorage.getItem(key));
            } catch (e) { /* ignore */ }
            try {
                var cookieMatch = document.cookie.match(
                    new RegExp('(?:^|; )' + key + '=([^;]*)')
                );
                if (cookieMatch && cookieMatch[1]) {
                    mergeFromRaw(decodeURIComponent(cookieMatch[1]));
                }
            } catch (e) { /* ignore */ }
            return pending;
        }

        function writePendingNewVersionToastMap(key, pending) {
            var payload = angular.toJson(pending || {});
            var hasEntries = pending && Object.keys(pending).length > 0;
            try {
                if (hasEntries) {
                    sessionStorage.setItem(key, payload);
                } else {
                    sessionStorage.removeItem(key);
                }
            } catch (e) { /* ignore */ }
            try {
                if (hasEntries) {
                    localStorage.setItem(key, payload);
                } else {
                    localStorage.removeItem(key);
                }
            } catch (e) { /* ignore */ }
            // Cookie bridges AngularJS shell ↔ ngx iframe across localhost ports.
            try {
                if (hasEntries) {
                    document.cookie = key + '=' + encodeURIComponent(payload) +
                        '; path=/; max-age=86400; SameSite=Lax';
                } else {
                    document.cookie = key + '=; path=/; max-age=0; SameSite=Lax';
                }
            } catch (e) { /* ignore */ }
        }

        function persistPendingNewVersionToast(contentId, title) {
            if (!contentId) {
                return;
            }
            try {
                var key = 'DocumentNewVersionToastPending';
                var pending = readPendingNewVersionToastMap(key);
                pending[contentId] = {
                    title: title || '',
                    createdAt: Date.now()
                };
                writePendingNewVersionToastMap(key, pending);
            } catch (e) {
                // Ignore storage errors.
            }
        }

        function showNewVersionUploadedToast() {
            function translateOrFallback(key, fallback) {
                var value = $filter('translate')(key);
                return (!value || value === key) ? fallback : value;
            }

            $mdToast.show({
                hideDelay: 8000,
                position: 'top right',
                toastClass: 'fp-new-version-toast',
                autoWrap: false,
                controller: ['$scope', '$mdToast', function ($toastScope, $mdToastInstance) {
                    $toastScope.closeToast = function () {
                        $mdToastInstance.hide();
                    };
                    $toastScope.lead = translateOrFallback(
                        'atheer.content.newVersionUploadedLead',
                        'A new version has been uploaded'
                    );
                    $toastScope.line1Rest = translateOrFallback(
                        'atheer.content.newVersionUploadedLine1Rest',
                        'with the'
                    );
                    $toastScope.line2 = translateOrFallback(
                        'atheer.content.newVersionUploadedLine2',
                        "previous version's properties. You can review"
                    );
                    $toastScope.line3 = translateOrFallback(
                        'atheer.content.newVersionUploadedLine3',
                        'and change the tags and settings.'
                    );
                }],
                template:
                    '<md-toast class="fp-new-version-toast" style="max-width:340px;">' +
                        '<div class="md-toast-content fp-new-version-toast__content" ' +
                            'style="display:flex;align-items:flex-start;max-width:340px;width:340px;' +
                            'height:auto;max-height:none;white-space:normal;padding:12px 4px 12px 16px;' +
                            'background:#323232;color:#fff;box-sizing:border-box;">' +
                            '<div class="fp-new-version-toast__message" ' +
                                'style="display:block;flex:1 1 auto;min-width:0;max-width:280px;' +
                                'white-space:normal;line-height:1.45;font-size:13px;padding-right:4px;">' +
                                '<div style="display:block;white-space:normal;">' +
                                    '<strong ng-bind="lead"></strong> <span ng-bind="line1Rest"></span>' +
                                '</div>' +
                                '<div style="display:block;white-space:normal;" ng-bind="line2"></div>' +
                                '<div style="display:block;white-space:normal;" ng-bind="line3"></div>' +
                            '</div>' +
                            '<md-button class="md-icon-button fp-new-version-toast__close" ' +
                                'style="margin:-4px 0 0;width:32px;height:32px;min-width:32px;color:#fff;" ' +
                                'ng-click="closeToast()" aria-label="Close">' +
                                '<md-icon md-font-icon="zmdi zmdi-close" style="color:#fff;"></md-icon>' +
                            '</md-button>' +
                        '</div>' +
                    '</md-toast>'
            });
        }

        vm.uploadStatus = 'idle';
        vm.processStatus = 'IDLE';
        vm.extractStatus = 'IDLE';
        vm.isDocumentForAI = false;
        vm.pendingGenerateAutoTags = false;

        var bulkUploadQueue = [];
        var isProcessingBulkUploadQueue = false;
        var bulkSavedDocuments = [];
        var isNewDocumentBulkSession = !id && !$stateParams.id;
        var documentMediaReadyPollIntervals = {};
        var bulkMediaReadyPollPromise = null;
        var bulkMediaReadyPollStartedAt = 0;
        var bulkCopilotProcessingSubmitted = false;
        var bulkUploadCompletionCallback = null;
        var bulkMediaReadyPollTimedOut = false;
        var MEDIA_READY_POLL_INTERVAL_MS = 3000;
        var MEDIA_READY_POLL_MAX_MS = 15 * 60 * 1000;

        function stopDocumentMediaReadyPoll(contentId) {
            if (!documentMediaReadyPollIntervals[contentId]) {
                return;
            }
            $interval.cancel(documentMediaReadyPollIntervals[contentId]);
            delete documentMediaReadyPollIntervals[contentId];
        }

        function stopAllDocumentMediaReadyPolls() {
            angular.forEach(documentMediaReadyPollIntervals, function (intervalPromise, contentId) {
                $interval.cancel(intervalPromise);
            });
            documentMediaReadyPollIntervals = {};
        }

        function stopBulkMediaReadyPoll() {
            if (bulkMediaReadyPollPromise) {
                $interval.cancel(bulkMediaReadyPollPromise);
                bulkMediaReadyPollPromise = null;
            }
            bulkMediaReadyPollStartedAt = 0;
        }

        function isNewDocumentBulkUploadContext() {
            return isNewDocumentBulkSession && !vm.isUploadingNewVersion;
        }

        function completeBulkUploadSession() {
            var savedDocs = bulkSavedDocuments.slice();
            var docsNeedingProcessing = savedDocs.filter(function (doc) {
                return doc.isDocumentForAI && doc.contentId;
            });
            var lastDoc = savedDocs.length ? savedDocs[savedDocs.length - 1] : null;

            if (!lastDoc) {
                vm.processStatus = 'IDLE';
                bulkSavedDocuments = [];
                return;
            }

            vm.processStatus = 'UPLOADED';

            if (docsNeedingProcessing.length) {
                bulkUploadCompletionCallback = function () {
                    transitionBulkUploadToReadyState(lastDoc);
                };
                startBulkCopilotProcessing();
                return;
            }

            bulkSavedDocuments = [];
            if (lastDoc) {
                watchDocumentMediaReady(lastDoc.contentId);
            }
        }

        function transitionBulkUploadToReadyState(lastDoc) {
            stopBulkMediaReadyPoll();
            bulkSavedDocuments = [];

            if (!lastDoc || !lastDoc.contentId) {
                vm.processStatus = 'READY';
                return;
            }

            Content.get({ id: lastDoc.contentId }, function (result) {
                if (!result) {
                    vm.processStatus = 'READY';
                    return;
                }

                vm.processStatus = 'COMPLETE';
                $timeout(function () {
                    vm.processStatus = 'READY';
                    vm.contentModel = result;
                    vm.isDocumentForAI = !!lastDoc.isDocumentForAI;
                    if (angular.isFunction(vm.syncAutoTagsOnModel)) {
                        vm.syncAutoTagsOnModel();
                    }
                    refreshDocumentVersions();
                    if (lastDoc.isDocumentForAI && vm.enableAutoGenerateTagsWithAI) {
                        if (lastDoc.shouldGenerateAutoTags) {
                            applyOptimisticPendingTagGenerationStatus();
                        }
                        vm.checkAndStartDocumentProcessStatusPoll();
                    }
                }, 2000);
            });
        }

        function invokeBulkUploadCompletionCallback() {
            if (!angular.isFunction(bulkUploadCompletionCallback)) {
                return;
            }
            var callback = bulkUploadCompletionCallback;
            bulkUploadCompletionCallback = null;
            callback();
        }

        function resetContentModelForNextBulkUpload() {
            var freshModel = angular.copy(vm.contentMetaData.default_model);
            freshModel.title = $filter('translate')(vm.contentMetaData.default_model.title);
            vm.contentModel = freshModel;
            vm.extractStatus = 'IDLE';
            vm.processStatus = 'IDLE';
            vm.uploadStatus = 'idle';
        }

        function applyDocumentUploadToModel(mediaId, responseObj, isRequiredForProcessing, documentTags, shouldGenerateAutoTags, options) {
            options = options || {};
            if (!options.suppressProcessStatus) {
                vm.processStatus = 'UPLOADED';
            }

            vm.contentModel.title = responseObj.name;
            vm.contentModel.description = responseObj.description;
            vm.contentModel.data.source_media = responseObj;
            vm.contentModel.data.doc_status = 'UPLOADED';
            vm.contentModel.external_id = responseObj.external_id;
            vm.contentModel.process_document = isRequiredForProcessing;
            vm.isDocumentForAI = isRequiredForProcessing;
            vm.pendingGenerateAutoTags = shouldGenerateAutoTags === true && vm.enableAutoGenerateTagsWithAI;
            vm.contentModel.tags = documentTags;
            delete vm.contentModel.data.auto_tags;
            delete vm.contentModel.auto_tags;
            if (vm.pendingGenerateAutoTags && !options.suppressProcessStatus) {
                applyOptimisticPendingTagGenerationStatus();
            }
        }

        function applyOptimisticPendingTagGenerationStatus() {
            if (!vm.enableAutoGenerateTagsWithAI) {
                return;
            }
            var currentStatus = vm.documentProcessingStatus && vm.documentProcessingStatus.status;
            if (isTerminalProcessStatus(currentStatus)) {
                return;
            }
            applyDocumentProcessingStatus({
                status: 'PENDING',
                errors: [],
                updated_at: new Date().toISOString()
            });
        }

        function submitBulkCopilotProcessing(docsToProcess) {
            if (!docsToProcess || !docsToProcess.length || bulkCopilotProcessingSubmitted) {
                return;
            }
            bulkCopilotProcessingSubmitted = true;

            var contentIds = docsToProcess.map(function (doc) {
                return doc.contentId;
            });
            var firstDoc = docsToProcess[0];
            var shouldGenerateTags = firstDoc.shouldGenerateAutoTags === true && vm.enableAutoGenerateTagsWithAI;

            Content.processDocument({
                tags: firstDoc.tags || [],
                content_ids: contentIds,
                should_process_document: true,
                should_generate_tags: shouldGenerateTags,
                should_generate_embeddings: !shouldGenerateTags
            }, function () {
                persistDocumentProcessingPollIds(contentIds);
                if (shouldGenerateTags &&
                    vm.contentModel &&
                    contentIds.indexOf(vm.contentModel.id) >= 0) {
                    applyOptimisticPendingTagGenerationStatus();
                }
                vm.startDocumentProcessStatusPoll(contentIds);
                invokeBulkUploadCompletionCallback();
            }, function () {
                persistDocumentProcessingPollIds(contentIds);
                invokeBulkUploadCompletionCallback();
            });
        }

        function checkBulkDocumentsMediaReady() {
            var docsToProcess = bulkSavedDocuments.filter(function (doc) {
                return doc.isDocumentForAI && doc.contentId;
            });

            if (!docsToProcess.length) {
                invokeBulkUploadCompletionCallback();
                return;
            }

            if (bulkMediaReadyPollStartedAt &&
                Date.now() - bulkMediaReadyPollStartedAt > MEDIA_READY_POLL_MAX_MS) {
                stopBulkMediaReadyPoll();
                bulkMediaReadyPollTimedOut = true;
                ToastService.displayToast($filter('translate')('atheer.content.documentProcessingStatusPollTimeout'));
            }

            var checksCompleted = 0;
            var readyDocs = [];
            var stillProcessing = false;

            function onCheckComplete() {
                if (checksCompleted !== docsToProcess.length) {
                    return;
                }

                if (readyDocs.length === docsToProcess.length) {
                    stopBulkMediaReadyPoll();
                    submitBulkCopilotProcessing(readyDocs);
                    return;
                }

                if (bulkMediaReadyPollTimedOut || !stillProcessing) {
                    stopBulkMediaReadyPoll();
                    if (readyDocs.length) {
                        submitBulkCopilotProcessing(readyDocs);
                    } else {
                        invokeBulkUploadCompletionCallback();
                    }
                }
            }

            function recordDocMediaStatus(doc, result) {
                if (result && result.id === doc.contentId && result.data) {
                    if (result.data.doc_status === 'READY') {
                        if (!readyDocs.some(function (readyDoc) {
                            return readyDoc.contentId === doc.contentId;
                        })) {
                            readyDocs.push(doc);
                        }
                    } else if (result.data.doc_status === 'FAILED') {
                        // Terminal state; do not wait for this document.
                    } else {
                        stillProcessing = true;
                    }
                } else {
                    stillProcessing = true;
                }
            }

            angular.forEach(docsToProcess, function (doc) {
                Content.get({ id: doc.contentId }, function (result) {
                    checksCompleted++;
                    recordDocMediaStatus(doc, result);
                    onCheckComplete();
                }, function () {
                    checksCompleted++;
                    stillProcessing = true;
                    onCheckComplete();
                });
            });
        }

        function startBulkCopilotProcessing() {
            stopBulkMediaReadyPoll();
            bulkCopilotProcessingSubmitted = false;
            bulkMediaReadyPollTimedOut = false;

            var docsToProcess = bulkSavedDocuments.filter(function (doc) {
                return doc.isDocumentForAI && doc.contentId;
            });

            if (!docsToProcess.length) {
                invokeBulkUploadCompletionCallback();
                return;
            }

            bulkMediaReadyPollStartedAt = Date.now();
            checkBulkDocumentsMediaReady();
            bulkMediaReadyPollPromise = $interval(
                checkBulkDocumentsMediaReady,
                MEDIA_READY_POLL_INTERVAL_MS
            );
        }

        function pollDocumentMediaReadyOnce(contentId) {
            Content.get({ id: contentId }, function (result) {
                if (!result || result.id !== contentId || !result.data) {
                    return;
                }

                if (result.data.doc_status === 'READY') {
                    stopDocumentMediaReadyPoll(contentId);
                    handleDocumentMediaReady(contentId, result);
                } else if (result.data.doc_status === 'FAILED') {
                    stopDocumentMediaReadyPoll(contentId);
                    if (vm.contentModel && vm.contentModel.id === contentId) {
                        vm.processStatus = 'FAILED';
                        vm.contentModel = result;
                    }
                }
            });
        }

        function watchDocumentMediaReady(contentId) {
            if (!contentId || documentMediaReadyPollIntervals[contentId]) {
                return;
            }

            pollDocumentMediaReadyOnce(contentId);
            documentMediaReadyPollIntervals[contentId] = $interval(function () {
                pollDocumentMediaReadyOnce(contentId);
            }, MEDIA_READY_POLL_INTERVAL_MS);
        }

        function processBulkUploadQueue() {
            if (isProcessingBulkUploadQueue || !bulkUploadQueue.length) {
                return;
            }

            isProcessingBulkUploadQueue = true;

            if (vm.contentModel && vm.contentModel.id) {
                resetContentModelForNextBulkUpload();
            }

            var upload = bulkUploadQueue.shift();
            applyDocumentUploadToModel(
                upload.mediaId,
                upload.responseObj,
                upload.isRequiredForProcessing,
                upload.documentTags,
                upload.shouldGenerateAutoTags,
                { suppressProcessStatus: true }
            );

            vm.updateContentModel();
            Content.save(vm.contentModel, function (result) {
                vm.onSaveSuccessNoAlert(result);
                bulkSavedDocuments.push({
                    contentId: result.id,
                    tags: upload.documentTags || [],
                    shouldGenerateAutoTags: upload.shouldGenerateAutoTags === true && vm.enableAutoGenerateTagsWithAI,
                    isDocumentForAI: !!upload.isRequiredForProcessing
                });
                isProcessingBulkUploadQueue = false;
                if (!bulkUploadQueue.length) {
                    completeBulkUploadSession();
                }
                processBulkUploadQueue();
            }, function () {
                vm.onSaveError();
                isProcessingBulkUploadQueue = false;
                if (!bulkUploadQueue.length) {
                    completeBulkUploadSession();
                }
                processBulkUploadQueue();
            });
        }

        vm.isExternalDocument = false;
        vm.fileMaxSize = 500 * 1024 * 1024;
        triLoaderService.setLoaderActive(false);

        function isTerminalProcessStatus(status) {
            return TERMINAL_PROCESS_STATUSES.indexOf(status) >= 0;
        }

        function isInProgressProcessStatus(status) {
            return !!status && IN_PROGRESS_PROCESS_STATUSES.indexOf(status) >= 0;
        }

        function mapStatusForAutoTagFeature(status) {
            if (!status || vm.enableAutoGenerateTagsWithAI) {
                return status;
            }
            if (status === 'PROCESSING_FOR_TAGS_GENERATION') {
                return 'IN_PROGRESS';
            }
            return status;
        }

        function applyDocumentProcessingStatus(statusEntry) {
            if (!statusEntry) {
                return;
            }
            vm.documentProcessingStatus = {
                status: mapStatusForAutoTagFeature(statusEntry.status),
                errors: statusEntry.errors || [],
                updated_at: statusEntry.updated_at
            };
            if (isInProgressProcessStatus(statusEntry.status) && vm.enableAutoGenerateTagsWithAI) {
                vm.contentMetaData.show_auto_tags = true;
            }
        }

        function getDocumentProcessingStatusLabel(status) {
            if (!status) {
                return '';
            }
            var key = 'atheer.content.documentProcessingStatus.' + status;
            var translated = $filter('translate')(key);
            return translated === key ? status : translated;
        }

        vm.getDocumentProcessingStatusLabel = getDocumentProcessingStatusLabel;

        vm.getActiveDocumentProcessingStatusLabel = function () {
            var status = vm.documentProcessingStatus && vm.documentProcessingStatus.status;
            if (!status && vm.contentModel && vm.contentModel.id && isContentIdPersistedForProcessPoll(vm.contentModel.id)) {
                status = vm.enableAutoGenerateTagsWithAI &&
                    (vm.isRegeneratingAutoTags || observedInProgressDuringRegeneration)
                    ? 'PROCESSING_FOR_TAGS_GENERATION'
                    : 'IN_PROGRESS';
            }
            return getDocumentProcessingStatusLabel(mapStatusForAutoTagFeature(status));
        };

        vm.onTagRegenerationStarted = function () {
            if (!vm.enableAutoGenerateTagsWithAI) {
                return;
            }
            tagRegenerationStartedAt = Date.now();
            observedInProgressDuringRegeneration = true;
            vm.isRegeneratingAutoTags = true;
            vm.contentMetaData.show_auto_tags = true;
            if (vm.contentModel && vm.contentModel.id) {
                setPollStartedAtForContent(vm.contentModel.id, tagRegenerationStartedAt, true);
            }
            applyDocumentProcessingStatus({
                status: 'PROCESSING_FOR_TAGS_GENERATION',
                errors: [],
                updated_at: new Date().toISOString()
            });
        };

        function completeTagRegeneration() {
            vm.isRegeneratingAutoTags = false;
            tagRegenerationStartedAt = 0;
            observedInProgressDuringRegeneration = false;
        }

        function shouldAcceptProcessStatusEntry(statusEntry, contentId) {
            if (!statusEntry) {
                return false;
            }
            if (!isStaleRegenerationStatusEntry(statusEntry)) {
                return true;
            }
            if (contentId && statusEntry.document_id !== contentId) {
                return false;
            }
            var localStatus = vm.documentProcessingStatus && vm.documentProcessingStatus.status;
            if (isTerminalProcessStatus(statusEntry.status)) {
                return (
                    vm.isRegeneratingAutoTags ||
                    vm.isPollingDocumentProcessStatus ||
                    isInProgressProcessStatus(localStatus) ||
                    isContentIdPersistedForProcessPoll(contentId)
                );
            }
            return false;
        }

        function handleTerminalDocumentProcessing(contentId, statusEntry) {
            if (!contentId || !statusEntry || !isTerminalProcessStatus(statusEntry.status)) {
                return false;
            }
            removePersistedDocumentProcessingPollIds([contentId]);
            applyDocumentProcessingStatus(statusEntry);
            if (statusEntry.status === 'FAILED') {
                ToastService.displayToast(getDocumentProcessingStatusLabel('FAILED'));
            } else if (statusEntry.status === 'READY_FOR_REVIEW' && vm.enableAutoGenerateTagsWithAI) {
                markDocumentAutoTagsUpdated(contentId);
                onDocumentProcessStatusComplete(contentId);
            }
            completeTagRegeneration();
            return true;
        }

        function isStaleRegenerationStatusEntry(statusEntry) {
            if (!statusEntry) {
                return false;
            }

            if (isInProgressProcessStatus(statusEntry.status)) {
                observedInProgressDuringRegeneration = true;
                return false;
            }

            if (!isTerminalProcessStatus(statusEntry.status)) {
                return false;
            }

            if (vm.isRegeneratingAutoTags || vm.isPollingDocumentProcessStatus || observedInProgressDuringRegeneration) {
                return false;
            }

            var contentId = statusEntry.document_id;
            return !!(
                contentId &&
                isContentIdPersistedForProcessPoll(contentId) &&
                getPollStartedAtForContent(contentId)
            );
        }

        vm.isDocumentProcessStatusInProgress = function () {
            var status = vm.documentProcessingStatus && vm.documentProcessingStatus.status;
            if (isTerminalProcessStatus(status)) {
                return false;
            }
            return vm.isRegeneratingAutoTags ||
                vm.isPollingDocumentProcessStatus ||
                (vm.contentModel && vm.contentModel.id && isContentIdPersistedForProcessPoll(vm.contentModel.id)) ||
                isInProgressProcessStatus(status);
        };

        function stopDocumentProcessStatusPoll() {
            if (vm.documentProcessStatusPollPromise) {
                $interval.cancel(vm.documentProcessStatusPollPromise);
                vm.documentProcessStatusPollPromise = null;
            }
            vm.isPollingDocumentProcessStatus = false;
        }

        var DOCUMENT_PROCESSING_POLL_IDS_KEY = 'DocumentProcessingPollIds';
        var DOCUMENT_PROCESSING_POLL_META_KEY = 'DocumentProcessingPollMeta';
        var DOCUMENT_AUTO_TAGS_UPDATED_KEY = 'DocumentAutoTagsUpdated';

        function getPersistedDocumentProcessingPollIds() {
            try {
                var raw = sessionStorage.getItem(DOCUMENT_PROCESSING_POLL_IDS_KEY);
                var ids = raw ? JSON.parse(raw) : [];
                return angular.isArray(ids) ? ids : [];
            } catch (e) {
                return [];
            }
        }

        function getDocumentProcessingPollMeta() {
            try {
                var raw = sessionStorage.getItem(DOCUMENT_PROCESSING_POLL_META_KEY);
                var meta = raw ? JSON.parse(raw) : {};
                return meta && typeof meta === 'object' ? meta : {};
            } catch (e) {
                return {};
            }
        }

        function getPollStartedAtForContent(contentId) {
            if (!contentId) {
                return 0;
            }
            var meta = getDocumentProcessingPollMeta();
            return meta[contentId] && meta[contentId].startedAt ? meta[contentId].startedAt : 0;
        }

        function setPollStartedAtForContent(contentId, startedAt, forceUpdate) {
            if (!contentId) {
                return;
            }
            var meta = getDocumentProcessingPollMeta();
            if (!meta[contentId] || forceUpdate) {
                meta[contentId] = {
                    startedAt: startedAt || Date.now()
                };
                sessionStorage.setItem(DOCUMENT_PROCESSING_POLL_META_KEY, angular.toJson(meta));
            }
        }

        function removePollMetaForContentIds(contentIds) {
            if (!contentIds || !contentIds.length) {
                return;
            }
            var meta = getDocumentProcessingPollMeta();
            var changed = false;
            angular.forEach(contentIds, function (contentId) {
                if (contentId && meta[contentId]) {
                    delete meta[contentId];
                    changed = true;
                }
            });
            if (changed) {
                sessionStorage.setItem(DOCUMENT_PROCESSING_POLL_META_KEY, angular.toJson(meta));
            }
        }

        function isContentIdPersistedForProcessPoll(contentId) {
            if (!contentId) {
                return false;
            }
            return getPersistedDocumentProcessingPollIds().indexOf(contentId) >= 0;
        }

        function getActiveProcessingStartedAt() {
            if (tagRegenerationStartedAt) {
                return tagRegenerationStartedAt;
            }
            var contentId = vm.contentModel && vm.contentModel.id;
            return contentId ? getPollStartedAtForContent(contentId) : 0;
        }

        function resumeProcessingPollTrackingIfNeeded(contentId) {
            if (!contentId || !isContentIdPersistedForProcessPoll(contentId)) {
                return false;
            }

            var currentStatus = vm.documentProcessingStatus && vm.documentProcessingStatus.status;
            if (isTerminalProcessStatus(currentStatus)) {
                removePersistedDocumentProcessingPollIds([contentId]);
                completeTagRegeneration();
                return false;
            }

            var pollStartedAt = getPollStartedAtForContent(contentId);
            if (!pollStartedAt) {
                pollStartedAt = Date.now();
                setPollStartedAtForContent(contentId, pollStartedAt);
            }
            if (!tagRegenerationStartedAt) {
                tagRegenerationStartedAt = pollStartedAt;
            }
            observedInProgressDuringRegeneration = true;

            if (!isInProgressProcessStatus(vm.documentProcessingStatus && vm.documentProcessingStatus.status)) {
                applyDocumentProcessingStatus({
                    status: vm.enableAutoGenerateTagsWithAI ? 'PROCESSING_FOR_TAGS_GENERATION' : 'IN_PROGRESS',
                    errors: [],
                    updated_at: new Date().toISOString()
                });
            }
            if (vm.enableAutoGenerateTagsWithAI) {
                vm.contentMetaData.show_auto_tags = true;
            }
            return true;
        }

        function persistDocumentProcessingPollIds(contentIds) {
            if (!contentIds || !contentIds.length) {
                return;
            }
            var merged = getPersistedDocumentProcessingPollIds();
            angular.forEach(contentIds, function (contentId) {
                if (contentId && merged.indexOf(contentId) === -1) {
                    merged.push(contentId);
                }
                setPollStartedAtForContent(contentId, getActiveProcessingStartedAt() || Date.now());
            });
            sessionStorage.setItem(DOCUMENT_PROCESSING_POLL_IDS_KEY, angular.toJson(merged));
        }

        function removePersistedDocumentProcessingPollIds(contentIds) {
            if (!contentIds || !contentIds.length) {
                return;
            }
            var remaining = getPersistedDocumentProcessingPollIds().filter(function (id) {
                return contentIds.indexOf(id) === -1;
            });
            if (remaining.length) {
                sessionStorage.setItem(DOCUMENT_PROCESSING_POLL_IDS_KEY, angular.toJson(remaining));
            } else {
                sessionStorage.removeItem(DOCUMENT_PROCESSING_POLL_IDS_KEY);
            }
            removePollMetaForContentIds(contentIds);
        }

        function markDocumentAutoTagsUpdated(contentId) {
            if (!contentId) {
                return;
            }
            try {
                sessionStorage.setItem(DOCUMENT_AUTO_TAGS_UPDATED_KEY, angular.toJson({
                    contentId: contentId,
                    updatedAt: Date.now()
                }));
            } catch (e) {
                // Ignore session storage errors.
            }
        }

        function consumeDocumentAutoTagsUpdated(contentId) {
            if (!contentId) {
                return false;
            }
            try {
                var raw = sessionStorage.getItem(DOCUMENT_AUTO_TAGS_UPDATED_KEY);
                var payload = raw ? JSON.parse(raw) : null;
                if (payload && payload.contentId === contentId) {
                    sessionStorage.removeItem(DOCUMENT_AUTO_TAGS_UPDATED_KEY);
                    return true;
                }
            } catch (e) {
                // Ignore session storage errors.
            }
            return false;
        }

        function onDocumentProcessStatusComplete(contentId) {
            Content.get({ id: contentId }, function (result) {
                if (!result || !vm || !vm.contentModel) {
                    return;
                }
                if (result.auto_tags != null) {
                    vm.contentModel.auto_tags = result.auto_tags;
                } else if (result.data && result.data.auto_tags != null) {
                    vm.contentModel.auto_tags = result.data.auto_tags;
                }
                if (angular.isFunction(vm.syncAutoTagsOnModel)) {
                    vm.syncAutoTagsOnModel();
                }
                if (angular.isFunction(vm.captureTagFieldsSnapshot)) {
                    vm.captureTagFieldsSnapshot();
                }
                markDocumentAutoTagsUpdated(contentId);
            });
        }

        function getProcessStatusTimestamp(entry) {
            var raw = (entry && (entry.updated_at || entry.created_at || entry.processing_started_at)) || 0;
            var parsed = Date.parse(raw);
            return isNaN(parsed) ? 0 : parsed;
        }

        function pickLatestProcessStatusEntry(entries) {
            if (!angular.isArray(entries) || !entries.length) {
                return null;
            }
            return entries.reduce(function (latest, entry) {
                if (!entry) {
                    return latest;
                }
                if (!latest) {
                    return entry;
                }
                return getProcessStatusTimestamp(entry) >= getProcessStatusTimestamp(latest) ? entry : latest;
            }, null);
        }

        function pickLatestProcessStatusesByDocumentId(results) {
            var latestByDocumentId = {};
            angular.forEach(results || [], function (entry) {
                if (!entry || !entry.document_id) {
                    return;
                }
                var existing = latestByDocumentId[entry.document_id];
                if (!existing || getProcessStatusTimestamp(entry) >= getProcessStatusTimestamp(existing)) {
                    latestByDocumentId[entry.document_id] = entry;
                }
            });
            return Object.keys(latestByDocumentId).map(function (documentId) {
                return latestByDocumentId[documentId];
            });
        }

        function pollDocumentProcessStatus(contentIds) {
            Content.getProcessStatus({
                ids: contentIds
            }, function (results) {
                if (!angular.isArray(results) || !results.length) {
                    return;
                }

                var latestResults = pickLatestProcessStatusesByDocumentId(results);
                var currentContentId = vm.contentModel && vm.contentModel.id;
                var currentEntry = currentContentId ? pickLatestProcessStatusEntry(latestResults.filter(function (entry) {
                    return entry && entry.document_id === currentContentId;
                })) : null;
                var currentEntryAccepted = false;

                if (currentEntry && shouldAcceptProcessStatusEntry(currentEntry, currentContentId)) {
                    if (isTerminalProcessStatus(currentEntry.status)) {
                        currentEntryAccepted = handleTerminalDocumentProcessing(currentContentId, currentEntry);
                    } else {
                        applyDocumentProcessingStatus(currentEntry);
                        currentEntryAccepted = true;
                    }
                }

                var terminalIds = [];
                angular.forEach(latestResults, function (statusEntry) {
                    if (!statusEntry || !statusEntry.document_id) {
                        return;
                    }
                    if (statusEntry.document_id === currentContentId && currentEntryAccepted) {
                        if (isTerminalProcessStatus(statusEntry.status)) {
                            terminalIds.push(statusEntry.document_id);
                        }
                        return;
                    }
                    if (!shouldAcceptProcessStatusEntry(statusEntry, statusEntry.document_id)) {
                        return;
                    }
                    if (isTerminalProcessStatus(statusEntry.status)) {
                        terminalIds.push(statusEntry.document_id);
                        if (statusEntry.document_id === currentContentId) {
                            handleTerminalDocumentProcessing(statusEntry.document_id, statusEntry);
                        }
                    } else {
                        applyDocumentProcessingStatus(statusEntry);
                    }
                });

                if (terminalIds.length) {
                    removePersistedDocumentProcessingPollIds(terminalIds);
                }

                var allTrackedTerminal = contentIds.every(function (contentId) {
                    return latestResults.some(function (entry) {
                        return entry &&
                            entry.document_id === contentId &&
                            isTerminalProcessStatus(entry.status) &&
                            shouldAcceptProcessStatusEntry(entry, contentId);
                    });
                });

                if (allTrackedTerminal) {
                    stopDocumentProcessStatusPoll();
                }
            }, function () {
                // Keep polling on transient errors; interval will retry in 5s
            });
        }

        vm.startDocumentProcessStatusPoll = function (contentIds) {
            if (!contentIds || !contentIds.length) {
                return;
            }
            stopDocumentProcessStatusPoll();
            vm.isPollingDocumentProcessStatus = true;
            observedInProgressDuringRegeneration = true;
            vm.documentProcessStatusPollStartedAt = Date.now();
            persistDocumentProcessingPollIds(contentIds);
            if (vm.enableAutoGenerateTagsWithAI &&
                contentIds.indexOf(vm.contentModel && vm.contentModel.id) >= 0 &&
                !isInProgressProcessStatus(vm.documentProcessingStatus && vm.documentProcessingStatus.status) &&
                !isTerminalProcessStatus(vm.documentProcessingStatus && vm.documentProcessingStatus.status)) {
                applyOptimisticPendingTagGenerationStatus();
            }
            pollDocumentProcessStatus(contentIds);
            vm.documentProcessStatusPollPromise = $interval(function () {
                if (Date.now() - vm.documentProcessStatusPollStartedAt > PROCESS_STATUS_POLL_MAX_MS) {
                    completeTagRegeneration();
                    stopDocumentProcessStatusPoll();
                    ToastService.displayToast($filter('translate')('atheer.content.documentProcessingStatusPollTimeout'));
                    return;
                }
                pollDocumentProcessStatus(contentIds);
            }, PROCESS_STATUS_POLL_INTERVAL_MS);
        };

        vm.checkAndStartDocumentProcessStatusPoll = function () {
            if (!vm.enableAutoGenerateTagsWithAI || !vm.contentModel || !vm.contentModel.id) {
                return;
            }

            var contentId = vm.contentModel.id;
            var hadExternalTagUpdate = consumeDocumentAutoTagsUpdated(contentId);
            if (hadExternalTagUpdate) {
                removePersistedDocumentProcessingPollIds([contentId]);
                completeTagRegeneration();
            }

            Content.getProcessStatus({
                ids: [contentId]
            }, function (results) {
                var statusEntry = pickLatestProcessStatusEntry((results || []).filter(function (entry) {
                    return entry && entry.document_id === contentId;
                }));

                if (statusEntry &&
                    isTerminalProcessStatus(statusEntry.status) &&
                    shouldAcceptProcessStatusEntry(statusEntry, contentId)) {
                    handleTerminalDocumentProcessing(contentId, statusEntry);
                    return;
                }

                var hasPersistedPoll = resumeProcessingPollTrackingIfNeeded(contentId);

                if (!statusEntry) {
                    if (hasPersistedPoll || isContentIdPersistedForProcessPoll(contentId)) {
                        vm.startDocumentProcessStatusPoll([contentId]);
                    } else if (hadExternalTagUpdate) {
                        onDocumentProcessStatusComplete(contentId);
                    }
                    return;
                }

                if (shouldAcceptProcessStatusEntry(statusEntry, contentId)) {
                    applyDocumentProcessingStatus(statusEntry);
                }

                if (isInProgressProcessStatus(statusEntry.status) &&
                    shouldAcceptProcessStatusEntry(statusEntry, contentId)) {
                    vm.startDocumentProcessStatusPoll([contentId]);
                    return;
                }

                if (hasPersistedPoll || isContentIdPersistedForProcessPoll(contentId)) {
                    vm.startDocumentProcessStatusPoll([contentId]);
                    return;
                }

                if (hadExternalTagUpdate) {
                    onDocumentProcessStatusComplete(contentId);
                }
            });
        };

        vm.triggerCopilotDocumentProcess = function (shouldGenerateAutoTags) {
            if (!vm.contentModel || !vm.contentModel.id || !vm.isDocumentForAI) {
                return;
            }
            var shouldGenerateTags = shouldGenerateAutoTags === true && vm.enableAutoGenerateTagsWithAI;
            Content.processDocument({
                tags: vm.contentModel.tags,
                content_ids: [vm.contentModel.id],
                should_process_document: true,
                should_generate_tags: shouldGenerateTags,
                should_generate_embeddings: !shouldGenerateTags
            }, function () {
                persistDocumentProcessingPollIds([vm.contentModel.id]);
                if (shouldGenerateTags) {
                    applyOptimisticPendingTagGenerationStatus();
                }
                vm.startDocumentProcessStatusPoll([vm.contentModel.id]);
            });
        };

        $scope.$on('$destroy', function () {
            var status = vm.documentProcessingStatus && vm.documentProcessingStatus.status;
            var contentId = vm.contentModel && vm.contentModel.id;
            if (contentId && isTerminalProcessStatus(status)) {
                removePersistedDocumentProcessingPollIds([contentId]);
                markDocumentAutoTagsUpdated(contentId);
            } else if (vm.isPollingDocumentProcessStatus && contentId && !isTerminalProcessStatus(status)) {
                persistDocumentProcessingPollIds([contentId]);
            }
            stopDocumentProcessStatusPoll();
            stopAllDocumentMediaReadyPolls();
            stopBulkMediaReadyPoll();
        });

        vm.createDocument = function (mediaId, responseObj, isRequiredForProcessing, documentTags, shouldGenerateAutoTags) {
            if (isNewDocumentBulkUploadContext()) {
                bulkUploadQueue.push({
                    mediaId: mediaId,
                    responseObj: responseObj,
                    isRequiredForProcessing: isRequiredForProcessing,
                    documentTags: documentTags,
                    shouldGenerateAutoTags: shouldGenerateAutoTags === true
                });
                if (bulkUploadQueue.length === 1 && !bulkSavedDocuments.length) {
                    vm.processStatus = 'UPLOADED';
                }
                processBulkUploadQueue();
                return;
            }

            applyDocumentUploadToModel(
                mediaId,
                responseObj,
                isRequiredForProcessing,
                documentTags,
                shouldGenerateAutoTags
            );

            if (vm.isUploadingNewVersion && vm.versionParentContent) {
                angular.extend(vm.contentModel, getVersionCreateFields(vm.versionParentContent));
                delete vm.contentModel.id;
                delete vm.contentModel.versioning;
                if (!documentTags || !documentTags.length) {
                    vm.contentModel.tags = angular.copy(vm.versionParentContent.tags || []);
                }
            }

            vm.save();

            vm.checkDocumentStatus();
        }

        $scope.$watch('vm.contentModel', function (newVal) {
            if (!vm.isNew()) {
                vm.checkDocumentStatus();
            }
        });

        function triggerCopilotDocumentProcessForContent(contentId, tags, shouldGenerateAutoTags) {
            if (!contentId) {
                return;
            }
            var shouldGenerateTags = shouldGenerateAutoTags === true && vm.enableAutoGenerateTagsWithAI;
            Content.processDocument({
                tags: tags || [],
                content_ids: [contentId],
                should_process_document: true,
                should_generate_tags: shouldGenerateTags,
                should_generate_embeddings: !shouldGenerateTags
            }, function () {
                persistDocumentProcessingPollIds([contentId]);
                if (vm.pendingNewVersionListingToast) {
                    persistPendingNewVersionToast(
                        contentId,
                        (vm.contentModel && vm.contentModel.title) || ''
                    );
                    vm.pendingNewVersionListingToast = false;
                }
                if (shouldGenerateTags && vm.contentModel && vm.contentModel.id === contentId) {
                    applyOptimisticPendingTagGenerationStatus();
                }
                vm.startDocumentProcessStatusPoll([contentId]);
            });
        }

        function handleDocumentMediaReady(pollingContentId, result) {
            if (!result || result.id !== pollingContentId) {
                return;
            }

            var isCurrentDocument = vm.contentModel && vm.contentModel.id === pollingContentId;

            if (isCurrentDocument) {
                vm.processStatus = 'COMPLETE';

                $timeout(function () {
                    vm.processStatus = 'READY';
                    vm.contentModel = result;
                    if (angular.isFunction(vm.syncAutoTagsOnModel)) {
                        vm.syncAutoTagsOnModel();
                    }
                    refreshDocumentVersions();
                    if (vm.isDocumentForAI) {
                        triggerCopilotDocumentProcessForContent(
                            pollingContentId,
                            result.tags,
                            vm.pendingGenerateAutoTags
                        );
                        vm.pendingGenerateAutoTags = false;
                    }
                }, 2000);
            } else if (vm.isDocumentForAI) {
                triggerCopilotDocumentProcessForContent(
                    pollingContentId,
                    result.tags,
                    vm.pendingGenerateAutoTags
                );
            }
        }

        vm.checkDocumentStatus = function () {
            if (isNewDocumentBulkSession) {
                return;
            }
            if ((vm.contentModel.data.doc_status == 'UPLOADED' || vm.contentModel.data.doc_status == 'PROCESSING') && vm.contentModel.id) {
                vm.processStatus = vm.contentModel.data.doc_status;
                watchDocumentMediaReady(vm.contentModel.id);
            } else {
                vm.processStatus = vm.contentModel.data.doc_status;
            }
        }

        vm.useEmbedCode = function () {
            vm.isExternalDocument = true;
            vm.extractStatus = 'EXTRACTING';

            $timeout(function () {
                vm.extractEmbedData();
            }, 1000);
        }

        vm.extractEmbedData = function () {
            vm.contentMetaData.show_tags = true;

            vm.contentModel.title = "Untitled";
            vm.contentModel.description = null;
            vm.contentModel.data.external_document = true;
            vm.contentModel.tags = null;
            vm.contentModel.data.use_custom_thumbnail = true;
            vm.contentModel.data.doc_status = "READY";
            vm.contentModel.data.thumbnail_url = null;
            vm.contentModel.data.embed_code = vm.contentModel.data.embed_code.replace(/width=\"[0-9]+\"/g, '').replace(/height=\"[0-9]+\"/g, '');

            vm.extractStatus = 'COMPLETE';

            $timeout(function () {
                vm.save();
                vm.extractStatus = 'READY';
            }, 1000);
        }

        vm.disableEmbedSubmit = function () {
            if (vm.contentModel.data.embed_code == null || vm.contentModel.data.embed_code.length <= 0) {
                return true;
            } else {
                return false;
            }
        }
    }
})();
